import PropTypes from 'prop-types';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import classNames from 'classnames';
import styles from './FJTextObjectEraseRight.module.less';

const FJTextObjectEraseRight = ({ isShow }) => {
    return (
        <div className={classNames(styles.app_right, { [styles.show]: isShow })}>
            <FJCreationPanelContainer />
        </div>
    );
};

FJTextObjectEraseRight.propTypes = {
    isShow: PropTypes.bool,
};

export default FJTextObjectEraseRight;
